import api from 'app/api';
import store from 'app/store';

const SET_USER_DATA = 'USER_LIST:DATA:SET';

export const getUserList = async (params, callback) => {
  const {
    searchText,
    selectedPage,
    pageSize,
  } = params;

  const successCallback = ({ data }) => {
    store.dispatch({ type: SET_USER_DATA, data: data });

    if (callback) callback(data);
  };

  await api.post(
    `/users/list/`,
    {
      [searchText]: true,
    },
    {
      id: 'save-user',
      success: {
        callback: successCallback,
      },
      params: {
        page_no: selectedPage,
        page_size: pageSize,
      },
    },
  );
};

export const getUserById = async (userId, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'USER_DATA:SET', data: data });

    if (callback) callback(data);
  };

  await api.get(
    `/users/${userId}/`,
    {
      id: 'get-user',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const updateListing = async (listingId, price, count, successCb, failureCb) => {

  const successCallback = ({ data }) => {
    if (successCb) successCb(data);
  };

  await api.put(
    `/tickets/${listingId}`,
    {
      price: price.toString(),
      count: count.toString(),
    },
    {
      success: {
        callback: successCallback,
      },
      failure: {
        callback: failureCb,
      },
    },
  );
};

export const deleteListing = async (listingId, callback, failureCb) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.delete(
    `/tickets/${listingId}`,
    {
      success: {
        callback: successCallback,
      },
      failure: {
        callback: failureCb,
      },
    },
  );
};

export const markListingAsSold = async (listingId, callback, failureCb) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.post(
    `/tickets/sold/${listingId}`,
    {},
    {
      success: {
        callback: successCallback,
      },
      failure: {
        callback: failureCb,
      },
    },
  );
};

export const getUserListing = async () => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'USER_LISTING:TICKETS:SET', data: data });
  };

  await api.get(
    `/tickets/listing`,
    {
      id: 'get-user-listing',
      success: {
        callback: successCallback,
      },
    },
  );
};
